import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import Element451WriterForm from '../forms/element451-writer-form';
import { element451WriterValidationSchema } from '../schema/element451Writer.js';

export default function Element451WriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Element451 Writer Node Details',
        altText: 'Element451 Writer Node',
        defaultLabel: 'Element451 Writer Node',
      }}
    >
      <CommonNode
        FormComponent={Element451WriterForm}
        schemaResolver={element451WriterValidationSchema}
      />
    </NodeProvider>
  );
}
